const Footer = () => {
    const handleClick = () => {
        return;
        if (document.documentElement.classList.contains("tanesw")) {
            document.documentElement.classList.remove("tanesw");
            document.documentElement.classList.add("tancis");
        } else if (document.documentElement.classList.contains("tancis")) {
            document.documentElement.classList.remove("tancis");
            document.documentElement.classList.add("tanoga");
        } else if (document.documentElement.classList.contains("tanoga")) {
            document.documentElement.classList.remove("tanoga");
            document.documentElement.classList.add("tanesw");
        }
    };
    return (
        <footer className="h-[200px] p-4 flex items-end justify-between" onClick={handleClick}>
            <span>{(process.env.REACT_APP_SYSTEM_GROUP || "").toUpperCase()} | 2025 © Tanzania Revenue Authority</span>
        </footer>
    );
};

export default Footer;
